export default "__VITE_ASSET__BAMPb_n9__"